import { render, staticRenderFns } from "./VCommentPrint.vue?vue&type=template&id=3cbd6e92&scoped=true"
import script from "./VCommentPrint.vue?vue&type=script&lang=js"
export * from "./VCommentPrint.vue?vue&type=script&lang=js"
import style0 from "./VCommentPrint.vue?vue&type=style&index=0&id=3cbd6e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbd6e92",
  null
  
)

export default component.exports